import React, { useState, useEffect } from 'react';
import { Layout, Row, Grid } from 'antd';
// import { isMobile, MobileView } from 'react-device-detect';
import { Link, withRouter } from 'react-router-dom';
// import { UserOutlined } from '@ant-design/icons';
// import { useSelector, useDispatch } from 'react-redux';
// import { flow } from 'lodash-es';
// actions
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import { PubnubConversationListProvider } from '../routes/direct-messages/context/PubnubConversationListContext';
// import AppFooter from './AppFooter';

const { Content, Footer, Sider } = Layout;

const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    // Code inside componentDidMount can be placed here
    // if there's any equivalent functionality needed.
  }, []);

  const screens = Grid.useBreakpoint();
  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };

  return (
    <PubnubConversationListProvider>
      <Layout style={{ minHeight: '100vh' }}>
        {screens.lg && (
          <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
            <Row className="logo" justify="center">
              <Link to="/">
                {collapsed ? (
                  <img
                    style={{ height: 30, width: 'auto' }}
                    src={require('../assets/img/logo-icon1.jpg')}
                    alt="Logo"
                  />
                ) : (
                  <img
                    style={{ height: 40, width: 'auto' }}
                    src="/img/logo_Strong_Body.svg"
                    alt="Logo"
                  />
                )}
              </Link>
            </Row>
            <AppSidebar />
          </Sider>
        )}

        <Layout className="site-layout">
          {/* <Header className="site-layout-background" style={{ padding: 0 }} /> */}
          <AppHeader></AppHeader>
          <Content style={{ margin: '16px 16px', overflow: 'auto' }}>
            <div className="site-layout-background" style={{ minHeight: 480 }}>
              {children}
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            StrongBody ©2025 Created by dashboard StrongBody
          </Footer>
        </Layout>
      </Layout>
    </PubnubConversationListProvider>
  );
};

export default withRouter(AppLayout);
